import { Analysis } from './analysis.model';
import { Contact } from './contact.model';
import { Location } from './location.model';

export interface Company {
  id: number;
  businessName: string;
  aidaLastSync?: Date;
  margoLastSync?: Date;
  aidaBusinessName?: string;
  VATNumber?: string;
  SDINumber?: string;
  lastBalanceSheetUrl?: string;
  taxCode: string;
  taxCodePrefix: string;
  IBAN?: string;
  SWIFT?: string;
  foundingDate?: string;
  businessStartDate?: string;
  REA?: string;
  legalForm?: string;
  legalStatus?: string;
  source: Source;
  website?: string;
  email?: string;
  certifiedEmail?: string;
  notes?: string;
  locations?: Location[];
  contacts?: Contact[];
  updatedAt: Date;
  createdAt: Date;
  analyses?: Analysis[];
  documents?: Document[];
  registeredOfficeAddress: string;
  registeredOfficeCity: string;
  registeredOfficeCountry: string;
  registeredOfficeState: string;
  registeredOfficeZip: string;
  notesActivity: string;
  notesContact: string;
  notesFinancial: string;
  notesManagement: string;
  legalRepresentative?: string;
  birthDate?: string;
  legalRepresentativeEmail?: string;
  legalRepresentativeFirstName?: string;
  IDIssueDate?: string;
  IDIssuePlace?: string;
  IDNumber?: string;
  legalRepresentativeLastName?: string;
  legalRepresentativePhone?: string;
  atecoName: string;
  atecoDescription: string;
  activityStatus: ActivityStatus;
  affiliateCompanies: AffiliateCompany[];
  ranking?: number;
  rankingUpdated?: Date;
  exp?: number;
  alerts?: string;
  tags: string[];
}

export interface CompanyListItem {
  id: number;
  businessName: string;
  source: Source;
  status: CompanyStatus;
  taxCodePrefix: string;
  taxCode: string;
  updatedAt: Date;
  statusId: number;
  partnerId: number;
  partnerAgentId: number;
  partnerEmail?: string;
  partnerBranch?: string;
}

export interface CompanyDto {
  businessName: string;
  taxCodePrefix: string;
  taxCode: string;
  legalForm?: string;
  contactEmail?: string;
  contactFirstName?: string;
  contactLastName: string;
  contactPhone?: string;
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  country?: string;
  zip?: string;
  companyPhone?: string;
  companyFax?: string;
  notes?: string;
}

export interface CompanyStatus {
  id: number;
  name: string;
  allowedCompanyType?: AllowedCompanyType;
}

export enum AllowedCompanyType {
  seller = 'SELLER',
  debtor = 'DEBTOR'
}

export enum Source {
  platform = 'PLATFORM',
  landingPage = 'LANDING_PAGE',
  phone = 'PHONE',
  drift = 'DRIFT',
  partner = 'PARTNER',
  event = 'EVENT',
  activeCustomer = 'ACTIVE_CUSTOMER',
  reverse = 'REVERSE',
  finservice = 'FINSERVICE',
  contactForm = 'CONTACT_FORM',
  other = 'OTHER',
}

export enum CompanyType {
  seller = 'SELLER',
  debtor = 'DEBTOR',
  buyer = 'BUYER',
  partner = 'PARTNER',
}

export enum CompanyImportType {
  seller = 'SELLER',
  debtor = 'DEBTOR',
  seller_debtor = 'SELLER_DEBTOR',
  debtor_seller = 'DEBTOR_SELLER'
}

export const CompanyImportTypeLabel = new Map<CompanyImportType, string>([
  [CompanyImportType.seller, 'MASSIVE_COMPANY_DIALOG.FILE_WARNING.SELLER'],
  [CompanyImportType.debtor, 'MASSIVE_COMPANY_DIALOG.FILE_WARNING.DEBTOR'],
  [CompanyImportType.seller_debtor, 'MASSIVE_COMPANY_DIALOG.FILE_WARNING.SELLER_DEBTOR'],
  [CompanyImportType.debtor_seller, 'MASSIVE_COMPANY_DIALOG.FILE_WARNING.DEBTOR_SELLER'],
]);

export enum ActivityStatus {
  Attiva = 'Attiva',
  'Non operativa' = 'Non operativa'
}

export interface AffiliateCompany {
  id: number;
  businessName: string;
  taxCode: string;
  percentShare: number;
}
